export enum SpreadsheetTitle {
  ACID_GAS_SULFUR = 'Acid Gas & Sulfur',
  STEAM_REPORT = 'Steam Report',
  HYDROGEN = 'Hydrogen',
}
